/* Generated by tools/build_sections.py from brand/hero.js.
   Edit there, not here. */
(function(){if(window.__efEnergy_hero)return;window.__efEnergy_hero=1;
/* EcoFlow Home Energy — the pinned hero.
 *
 * Five cards. The stage sticks for the length of a tall track and the card
 * advances with scroll position — no timer, so the hero never moves under a
 * reader who is standing still, and never stalls on a reader who is not.
 *
 * WHAT MOVES AND WHAT STEPS
 * Images crossfade CONTINUOUSLY: opacity is written per frame from the exact
 * scroll position, so dragging the scrollbar scrubs the hero. Text does NOT —
 * a headline half-dissolved into a different headline is unreadable, so the
 * copy steps to the nearest card with a short fade of its own, in CSS.
 *
 * The inline transitions the design put on the layers (900ms opacity, 7s
 * transform) are for a TIMED carousel. They fight a per-frame write — each
 * frame would start a new 900ms animation toward a value already stale — so
 * this file clears them on the elements it drives.
 *
 * NOT PINNED AT ALL under reduced motion or without JavaScript: the track
 * collapses to one screen and the first card stands. 330vh of scrolling to
 * read one headline is not an accessible fallback.
 */
(function () {
  "use strict";

  var doc = document;
  var pin = doc.querySelector("[data-hero-pin]");
  if (!pin) return;

  var layers = [].slice.call(pin.querySelectorAll("[data-hero-layer]"));
  var copies = [].slice.call(pin.querySelectorAll("[data-hero-copy]"));
  var rail = [].slice.call(pin.querySelectorAll("[data-hero]"));
  var n = layers.length;
  if (n < 2) return;

  var reduced = window.matchMedia &&
                window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function paintCopy(i) {
    copies.forEach(function (c, k) {
      if (k === i) {
        c.setAttribute("data-hero-on", "");
        c.removeAttribute("aria-hidden");
      } else {
        c.removeAttribute("data-hero-on");
        c.setAttribute("aria-hidden", "true");   /* only the shown card is read */
      }
    });
    rail.forEach(function (b, k) {
      var on = k === i;
      b.style.color = on ? "var(--ef-white)" : "rgba(255,255,255,0.55)";
      b.setAttribute("aria-current", on ? "true" : "false");
    });
  }

  if (reduced) {
    /* The CSS has already unpinned the track; just make sure one card shows. */
    layers.forEach(function (l, k) { l.style.opacity = k === 0 ? "1" : "0"; });
    paintCopy(0);
    return;
  }

  /* The design's inline transitions belong to a timed carousel. Clear them on
     everything this file writes to, or every frame restarts a 900ms tween. */
  layers.forEach(function (l) {
    l.style.transition = "none";
    var inner = l.firstElementChild;
    if (inner) inner.style.transition = "none";
  });

  var ticking = false, lastCard = -1, manual = 0;

  /* components.css unpins .ef-pin below 768px on purpose — pinning a viewport
     fights a touch scroll. So the hero has TWO modes, and which one is live is
     a question for the layout, not for a breakpoint copied into this file:
     if the track is no taller than the viewport, there is nothing to scrub and
     the rail drives the cards directly. Without this the unpinned hero read
     scroll progress off a zero-length track and sat on the last card. */
  function pinned() {
    var vh = window.innerHeight || doc.documentElement.clientHeight;
    return pin.offsetHeight - vh > 1;
  }

  function apply() {
    ticking = false;
    var r = pin.getBoundingClientRect();
    var vh = window.innerHeight || doc.documentElement.clientHeight;
    var span = r.height - vh;
    if (span <= 1) {                       /* unpinned: the rail is the control */
      paintCards(manual);
      return;
    }
    /* Progress of the sticky stage through its track, clamped so the hero
       holds its first and last card rather than flickering past them. */
    var p = Math.min(1, Math.max(0, -r.top / span));
    var f = p * (n - 1);

    paintCards(f);
  }

  function paintCards(f) {
    for (var i = 0; i < n; i++) {
      var d = Math.abs(f - i);
      var o = d >= 1 ? 0 : 1 - d;          /* linear crossfade with neighbours */
      layers[i].style.opacity = o.toFixed(3);
      layers[i].style.zIndex = o > 0.5 ? "2" : "1";
      var inner = layers[i].firstElementChild;
      if (inner) {
        /* The slow push-in the design gave the active card, driven by position
           instead of by a seven-second clock: 1 at the card's start, 1.06 at
           the next card's. */
        /* The first card has no arrival ramp — nothing precedes it — so it
           would sit at its end scale from the first frame. Give it the push
           across its own departure instead, which reads as the hero waking up
           as you start to scroll. */
        var local = i === 0 ? Math.min(1, Math.max(0, f))
                            : Math.min(1, Math.max(0, f - i + 1));
        inner.style.transform = "scale(" + (1 + 0.06 * local).toFixed(4) + ")";
      }
    }

    var card = Math.round(f);
    if (card !== lastCard) { paintCopy(card); lastCard = card; }

    /* The rail's little progress bars: filled behind the current card, part
       filled on it, empty ahead. */
    rail.forEach(function (b, k) {
      var track = b.firstElementChild, fill = track && track.firstElementChild;
      if (!fill) return;
      var pct = f >= k + 1 ? 100 : f <= k ? 0 : (f - k) * 100;
      fill.style.transition = "none";
      fill.style.width = pct.toFixed(1) + "%";
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }

  /* The rail is the manual control: clicking a card scrolls to the point in
     the track where that card is current, so the scrubbing and the buttons
     cannot disagree about which card is showing. */
  rail.forEach(function (b, k) {
    b.addEventListener("click", function () {
      if (!pinned()) {                     /* phone: switch the card in place */
        manual = k;
        paintCards(k);
        return;
      }
      var vh = window.innerHeight || doc.documentElement.clientHeight;
      var span = pin.offsetHeight - vh;
      window.scrollTo({ top: Math.round(pin.offsetTop + span * (k / (n - 1))),
                        behavior: "smooth" });
    });
  });

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  apply();

  window.EcoFlowEnergy = window.EcoFlowEnergy || {};
  window.EcoFlowEnergy.hero = {
    cards: n,
    go: function (k) { rail[k] && rail[k].click(); },
    read: function () { return { card: lastCard }; }
  };
})();

})();
